import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { isTeoremaActivateGuard } from './auth/is-teorema.guard';
import { ProfileModulesGuard } from './auth/profile-modules.guard';
import { AutoLoginComponent } from './commons/auto-login/auto-login.component';
import { PaymentLinksPageComponent } from './modules/payment-links/page/payment-links-page.component';
import { RegisterComponent } from './modules/register/register.component';
//import { LayoutComponent } from './shared/components/layout/layout.component';
import { LayoutV2Component as LayoutComponent } from './shared/components/layout-v2/layout-v2.component';
const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: 'auto-login',
    component: AutoLoginComponent,
  },
  {
    path: 'cadastro',
    component: RegisterComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard],
      },
      {
        path: '',
        loadChildren: () => import('./modules/quotes/quotes.module').then(m => m.QuotesModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'pessoas',
        loadChildren: () => import('./modules/people/people.module').then(m => m.PeopleModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
      },
      {
        path: 'itens',
        loadChildren: () => import('./modules/items/items.module').then(m => m.ItemsModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
      },
      {
        path: 'familias',
        loadChildren: () =>
          import('./modules/families/families.module').then(m => m.FamiliesModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Family'],
        },
      },
      {
        path: 'chamados',
        loadChildren: () =>
          import('./modules/ticket-center/ticket-center.module').then(m => m.TicketCenterModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Tickets'],
          onlyCompanyUsers: true,
        },
      },
      {
        path: 'roadmap-chamados',
        loadChildren: () =>
          import('./modules/ticket-roadmap/ticket-roadmap.module').then(m => m.TicketRoadmapModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Roadmap'],
          onlyCompanyUsers: true,
        },
      },
      {
        path: 'grupo-fiscal',
        loadChildren: () =>
          import('./modules/fiscal-groups/fiscal-groups.module').then(m => m.FiscalGroupsModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['FiscalGroups'],
        },
      },
      {
        path: 'operacoes-fiscais',
        loadChildren: () =>
          import('./modules/fiscal-operations/fiscal-operations.module').then(
            m => m.FiscalOperationsModule
          ),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['FiscalOperations'],
        },
      },
      {
        path: 'situacoes-fiscais',
        loadChildren: () =>
          import('./modules/fiscal-situations/fiscal-situations.module').then(
            m => m.FiscalSituationsModule
          ),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['FiscalSituations'],
        },
      },
      {
        path: 'grupos',
        loadChildren: () => import('./modules/groups/groups.module').then(m => m.GroupsModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Group'],
        },
      },
      {
        path: 'departamentos',
        loadChildren: () =>
          import('./modules/departments/departments.module').then(m => m.DepartmentsModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Departments'],
        },
      },
      {
        path: 'subgrupos',
        loadChildren: () =>
          import('./modules/subgroups/subgroups.module').then(m => m.SubGroupsModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['SubGroup'],
        },
      },
      {
        path: 'pedidos',
        loadChildren: () => import('./modules/orders/orders.module').then(m => m.OrdersModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Orders'],
        },
      },
      {
        path: 'orcamentos',
        loadChildren: () =>
          import('./modules/orders/budgets/budgets.module').then(m => m.BudgetsModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Budgets'],
        },
      },
      {
        path: 'devolucoes',
        loadChildren: () =>
          import('./modules/orders/devolutions/devolutions.module').then(m => m.DevolutionsModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Orders'],
        },
      },
      {
        path: 'compras',
        loadChildren: () =>
          import('./modules/purchase-orders/purchase-orders.module').then(
            m => m.PurchaseOrdersModule
          ),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['PurchaseOrders'],
        },
      },
      {
        path: 'beta-pedidos',
        redirectTo: 'v3ndor/pedidos',
        pathMatch: 'full',
      },
      {
        path: 'beta-pedidos-antigo',
        loadChildren: () =>
          import('./modules/beta-orders/beta-orders.module').then(m => m.BetaOrdersModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Orders'],
        },
      },
      {
        path: 'marcas',
        loadChildren: () => import('./modules/brands/brands.module').then(m => m.BrandsModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Brand'],
        },
      },
      {
        path: 'notas-fiscais',
        loadChildren: () =>
          import('./modules/invoices/invoices.module').then(m => m.InvoicesModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Invoices'],
        },
      },
      {
        path: 'notas-inutilizadas',
        loadChildren: () =>
          import('./modules/invoice-disablements/invoice-disablements.module').then(
            m => m.InvoiceDisablementsModule
          ),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Invoices'],
          onlyCompanyUsers: true,
        },
      },
      {
        path: 'financeiros',
        loadChildren: () =>
          import('./modules/installments/installments.module').then(m => m.InstallmentsModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Launchs'],
        },
      },
      {
        path: 'metodos-de-pagamento',
        loadChildren: () =>
          import('./modules/payment-methods/payment-methods.module').then(
            m => m.PaymentMethodsModule
          ),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['PaymentMethod'],
        },
      },
      {
        path: 'condicoes-pagamento',
        loadChildren: () =>
          import('./modules/payment-conditions/payment-conditions.module').then(
            m => m.PaymentConditions
          ),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['PaymentConditions'],
        },
      },
      {
        path: 'contas',
        loadChildren: () =>
          import('./modules/accounts/accounts.module').then(m => m.AccountsModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Accounts'],
        },
      },
      {
        path: 'categorias-financeiro',
        loadChildren: () =>
          import('./modules/categories/categories.module').then(m => m.CategoriesModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Category'],
        },
      },
      {
        path: 'a-pagar',
        loadChildren: () =>
          import('./modules/bills-to-pay/bills-to-pay.module').then(m => m.BillsToPayModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Installments', 'Launchs'],
        },
      },
      {
        path: 'a-receber',
        loadChildren: () =>
          import('./modules/bills-to-receive/bills-to-receive.module').then(
            m => m.BillsToReceiveModule
          ),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Installments', 'Launchs'],
        },
      },
      {
        path: 'movimento-contas',
        loadChildren: () =>
          import('./modules/checking-accounts/checking-accounts.module').then(
            m => m.CheckingAccountModule
          ),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['CheckingAccount'],
        },
      },
      {
        path: 'dispositivos',
        loadChildren: () => import('./modules/devices/devices.module').then(m => m.DevicesModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['DevicesRegistered'],
        },
      },
      {
        path: 'tipos',
        loadChildren: () =>
          import('./modules/item-types/item-types.module').then(m => m.ItemTypesModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['ItemType'],
        },
      },
      {
        path: 'subtipos',
        loadChildren: () =>
          import('./modules/item-sub-types/item-sub-types.module').then(m => m.ItemSubTypesModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['ItemSubType'],
        },
      },
      {
        path: 'controles',
        loadChildren: () =>
          import('./modules/item-controls/item-controls.module').then(m => m.ItemControlsModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['ItemControl'],
        },
      },
      {
        path: 'marketing',
        loadChildren: () =>
          import('./modules/marketing/marketing.module').then(m => m.MarketingModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
      },
      {
        path: 'centros-de-custo',
        loadChildren: () =>
          import('./modules/cost-centers/cost-centers.module').then(m => m.CostCentersModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['CostCenter'],
        },
      },
      {
        path: 'observacoes',
        loadChildren: () =>
          import('./modules/observations/observations.module').then(m => m.ObservationsModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Observations'],
        },
      },
      {
        path: 'avisos',
        loadChildren: () => import('./modules/notices/notices.module').then(m => m.NoticesModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Notices'],
        },
      },
      {
        path: 'rotas',
        loadChildren: () => import('./modules/routes/routes.module').then(m => m.RoutesModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Routes'],
        },
      },
      {
        path: 'consents',
        loadChildren: () =>
          import('./modules/lgpd-consents/lgpd-consents.module').then(m => m.LgpdConsentsModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['LGPDConsents'],
          onlyCompanyUsers: true,
        },
      },
      {
        path: 'licenses',
        loadChildren: () =>
          import('./modules/licenses/licenses.module').then(m => m.LicensesModule),
        data: {
          requiredModules: ['RegisteredSystems'],
        },
      },
      {
        path: 'licencas-usuario',
        loadChildren: () =>
          import('./modules/user-licenses/user-licenses.module').then(m => m.UserLicensesModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Licenses'],
          onlyCompanyUsers: true,
        },
      },
      {
        path: 'sac',
        loadChildren: () => import('./modules/sac/sac.module').then(m => m.SacModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Tickets'],
        },
      },
      {
        path: 'suporte/chamados',
        loadChildren: () => import('./modules/support/support.module').then(m => m.SupportModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['SupportTickets'],
        },
      },
      {
        path: 'crm',
        loadChildren: () => import('./modules/crm/crm.module').then(m => m.CrmModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
      },
      {
        // Cadastros de IA e execuções (chamado 0000579137). Cada rota filha traz seus módulos Ai*.
        path: 'ia',
        loadChildren: () => import('./features/ai/ai.routes').then(m => m.AI_ROUTES),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: [
            'AiProviders',
            'AiModels',
            'AiAgents',
            'AiSkills',
            'AiPipelines',
            'AiTriggers',
          ],
          needAllModules: false,
        },
      },
      {
        // Chamado 0000580000 — central de integrações do cliente (grupo logado). A Teorema tem a
        // sua em /integracao/central, com a lista de todos os grupos.
        path: 'integracoes',
        loadComponent: () =>
          import('./modules/integration-panel-page/integration-panel-page.component').then(
            m => m.IntegrationPanelPageComponent
          ),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          title: 'Integrações',
          requiredModules: ['IntegrationPanel'],
          onlyCompanyUsers: true,
        },
      },
      {
        // Chamado 0000580000 — menu Integração da Teorema (central de integrações de todos os
        // grupos). Fora do Manager de propósito: tem módulo próprio (IntegrationAdmin).
        path: 'integracao',
        loadChildren: () =>
          import('./modules/integration-admin/integration-admin.module').then(
            m => m.IntegrationAdminModule
          ),
        canActivate: [AuthGuard, ProfileModulesGuard, isTeoremaActivateGuard],
      },
      {
        path: 'manager',
        loadChildren: () => import('./modules/manager/manager.module').then(m => m.ManagerModule),
        canActivate: [AuthGuard, ProfileModulesGuard, isTeoremaActivateGuard],
      },
      {
        path: 'configuracoes',
        loadChildren: () =>
          import('./modules/configurations/configurations.module').then(
            m => m.ConfigurationsModule
          ),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: [
            'CONFIGURATIONS',
            'GeneralSettings',
            'RocketSettings',
            'QuickFilterSettings',
            'StockSettings',
            'DropshipSettings',
            'EmailSettings',
            'Integrations',
            'FilterSettings',
            'ParameterSettings',
          ],
          needAllModules: false,
        },
      },
      {
        path: 'relatorios',
        loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          // Este guard roda ANTES de o módulo lazy carregar, então é ele que
          // decide o acesso a /relatorios. Todo módulo de relatório precisa estar
          // listado aqui, senão o item aparece no menu e o clique cai em
          // /acesso-negado (`needAllModules: false` = basta um).
          requiredModules: ['Reports', 'CheckingAccountReports', 'CashierReports'],
          needAllModules: false,
        },
      },
      {
        path: 'templates',
        loadChildren: () =>
          import('./modules/templates/templates.module').then(m => m.TemplatesModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['CONFIGURATIONS'],
          needAllModules: false,
        },
      },
      {
        path: 'sessoes',
        loadChildren: () =>
          import('./modules/sessions/sessions.module').then(m => m.SessionsModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          // requiredModules: ['DevicesRegistered']
        },
      },
      {
        path: 'documentacoes',
        loadChildren: () =>
          import('./modules/documentation/documentation.module').then(m => m.DocumentationModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          onlySupportUsers: true,
          requiredModules: [],
        },
      },
      {
        path: 'analise-cadastral',
        loadChildren: () =>
          import('./modules/cadastral-analyses/cadastral-analyses.module').then(
            m => m.CadastralAnalysesModule
          ),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['PersonCadastralAnalysis'],
        },
      },
      {
        path: 'arquivos',
        loadChildren: () => import('./modules/assets/assets.module').then(m => m.AssetsModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['Assets'],
        },
      },
      {
        path: 'links-pagamento',
        component: PaymentLinksPageComponent,
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          title: 'Links de pagamento',
          requiredModules: ['PaymentLinks'],
        },
      },
      {
        path: 'teo-wiki',
        loadChildren: () => import('./modules/teo-wiki/teo-wiki.module').then(m => m.TeoWikiModule),
        canActivate: [AuthGuard, ProfileModulesGuard, isTeoremaActivateGuard],
        // data: {
        //   requiredModules: ['BwProject'],
        // },
      },
      {
        path: 'auditoria',
        loadChildren: () => import('./modules/audits/audits.module').then(m => m.AuditsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'importar-exportar',
        loadChildren: () =>
          import('./modules/import-export/import-export.module').then(m => m.ImportExportModule),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          requiredModules: ['ImportExportVendor'],
        },
      },
      {
        path: 'v3ndor',
        loadChildren: () => import('./features/v3ndor/v3ndor.module').then(m => m.V3ndorModule),
        canActivate: [AuthGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
